import hexRgb from "hex-rgb";

export function hexToRGBA(hex: string, alpha?: number) {
  const rgbaObj = hexRgb(hex);

  return `rgba(${rgbaObj.red}, ${rgbaObj.green}, ${rgbaObj.blue}, ${alpha ?? rgbaObj.alpha})`;
}
